import { render, staticRenderFns } from "./WorkOrdersTemplate.vue?vue&type=template&id=2d63b726&"
import script from "./WorkOrdersTemplate.vue?vue&type=script&lang=js&"
export * from "./WorkOrdersTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports